/** The Servwell mark. Kept as inline SVG — it is on the sign-in screen, so it must
 *  render before any asset request resolves. */
export function BrandMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
      <rect width="512" height="512" rx="112" fill="#ff6b35" />
      <path
        d="M330 176c-14-20-40-32-74-32-52 0-86 26-86 66 0 34 24 52 70 62l24 5c26 6 36 13 36 27 0 16-16 26-42 26-28 0-46-12-54-33l-46 20c14 34 50 55 100 55 58 0 94-28 94-70 0-36-24-54-72-65l-24-5c-25-6-34-12-34-25 0-15 14-24 38-24 24 0 40 10 48 28z"
        fill="#16181d"
      />
    </svg>
  );
}
